
/**
 *
 * NOTICE OF LICENSE
 *
 * This source file is released under commercial license by Lamia Oy.
 *
 * @copyright Copyright (c) Lamia Oy (https://lamia.fi)
 *
 */

export default {
    name: 'OpusTitle',
    props: {
        /**
         * Which tag component should use for rendering. Allowed tags: h1-h6 and span
         */
        tag: {
            type: String,
            default: 'h2',
            required: false,
            validator(tag) {
                return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span'].includes(tag);
            },
        },
        size: {
            type: String,
            default: 'h2',
            required: false,
            validator(tag) {
                return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'span'].includes(tag);
            },
        },
        /**
         * Render className for text alignment. Allowed values: left, center, right
         */
        textAlign: {
            type: String,
            default: 'center',
            required: false,
            validator(textAlign) {
                return ['left', 'center', 'right'].includes(textAlign);
            },
        },
        /**
         * Content of the title
         */
        content: {
            type: String,
            required: false,
            default: '',
        },
    },
    render(h) {
        const map = {
            h1: 'font-semibold text-[26px] leading-[38px] lg:text-[32px] lg:leading-[44px]',
            h2: 'font-semibold text-2xl leading-[32px] lg:text-[28px] lg:leading-9',
            h3: 'font-semibold text-xl lg:text-2xl',
            h4: 'font-semibold text-lg leading-6 lg:text-xl',
            h5: 'font-semibold text-base leading-5 lg:text-lg lg:leading-6',
        };
        const data = {
            class: {
                [this.tag]: true,
                [`text--${this.textAlign}`]: true,
                [map[this.size]]: true,
            },
        };

        return h(this.tag, data, [this.content || this.$slots.default]);
    },
};
